export { coreContext } from './context';
export { coreFileFetcher, fileFetcher } from './file_fetcher';
export { coreDifference } from './difference';
export { coreGraph } from './graph';
export { coreHistory } from './history';
export { coreLocalizer, t, localizer } from './localizer';
export { locationManager } from './location_manager';
export { prefs } from './preferences';
export { coreTree } from './tree';
export { coreUploader } from './uploader';
export { coreValidator } from './validator';
